import Joi from "joi";
import PropTypes from 'prop-types';

import Button from "../../themed/button";
import Form from "../../common/form";

import toastService from "../../../services/toastService";

class ConcreteHammerRangeFormEdit extends Form {
    state = { 
        data: {
			readingStartRange: 0,
            readingEndRange: 0,
		},
		errors: {},
		loading: false,
		progress: 0,
    };

    schema = {
        readingStartRange: Joi.number().positive().required().label('Reading Start Range'),
        readingEndRange: Joi.number().when('readingStartRange', {
            is: Joi.number().integer().positive().required(),
            then: Joi.number().integer().positive().greater(Joi.ref('readingStartRange')).required().label('Reading End Range'),
        }),
    };

    static propTypes = {
        initialRangeData: PropTypes.object,
        onEdit: PropTypes.func,
        onCancelEdit: PropTypes.func,
    }

    componentDidMount() {
        if (this.props.initialRangeData) {
            this.setState({ data: this.props.initialRangeData });
        }
    }

    doSubmit = () => {
        this.props.onEdit({
            readingStartRange: +this.state.data.readingStartRange,
            readingEndRange: +this.state.data.readingEndRange,
        });

        toastService.success('Saved Successfully!');
    }

    render() { 
        return ( 
            <form onSubmit={this.handleSubmit}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col">
                            {this.renderInput({
                                name: 'readingStartRange',
                                type: 'number',
                                label: 'Reading Start Range',
                                placeholder: 'Enter Reading Start Range'
                            })}
                        </div>
                        <div className="col">
                            {this.renderInput({
                                name: 'readingEndRange',
                                type: 'number',
                                label: 'Reading End Range',
                                placeholder: 'Enter Reading End Range'
                            })}
                        </div>
                    </div>

                    <div className="d-flex justify-content-end">
                        <div className="me-4">
                            <Button
                                label='Cancel' 
                                onClick={this.props.onCancelEdit}
                                style={{ backgroundColor: 'red' }} 
                            />
                        </div>

                        {this.renderButton('Save Data Changes')}
                    </div>
                </div>
            </form>
         );
    }
}
 
export default ConcreteHammerRangeFormEdit;